import React, { Fragment, useState } from "react";
import { Button } from "reactstrap";
import MonitoredItemGroupModal from "../MonitoredItemGroupModal";
import MonitorMethodModal from "../MonitorMethodModal";

const MonitoredItemModal = (props) => {
  const { isOpen, selectedItem, onModalEvent } = props;
  const [page, setPage] = useState(1);

  const baseHeader = ({ page, style }) => {
    if (page > 1) {
      return (
        <Button
          className="mb-2 mr-2 btn-icon btn-icon-only btn-dashed"
          outline
          color="info"
          style={style}
          onClick={() => setPage(page - 1)}
        >
         <i className="pe-7s-angle-left btn-icon-wrapper"> </i>
        </Button>
      );
    } else
      return (
        <Button
          className="mb-2 mr-2 btn-icon btn-icon-only btn-dashed"
          outline
          color="info"
          style={style}
          onClick={() => setPage(page + 1)}
        >
         <i className="pe-7s-angle-right btn-icon-wrapper"> </i>
        </Button>
      );
  };

  const onPageRender = () => {
    if (page == 1) {
      return (
        <MonitorMethodModal
          isOpen={isOpen}
          selectedItem={selectedItem}
          onModalEvent={onModalEvent}
          baseHeader={baseHeader}
          page={1}
        />
      );
    } else {
      return (
        <MonitoredItemGroupModal
          isOpen={isOpen}
          selectedItem={selectedItem}
          onModalEvent={onModalEvent}
          baseHeader={baseHeader}
          page={2}
        />
      );
    }
  };

  return <Fragment>{onPageRender()}</Fragment>;
};

export default MonitoredItemModal;
